<template>
    <div class="pagination">
        <!-- <div class="page_btn arr_left"></div> -->

        <div class="page_btn pg_first" :class="{on:active==1}" @click="postPage(1)">1</div>

        <div class="page_btn pg_eillip" v-if="active>3">...</div>
        
        <template v-for="(i,n) in [active-1,active,active+1]">
            <div class="page_btn"                 
                v-if="i>1&&i<count" 
                :class="{on:active==i}" 
                v-text="i"
                :key="n"
                @click="postPage(i)"></div>
        </template>

        <div class="page_btn pg_eillip" v-if="active<count-2">...</div>

        <div class="page_btn pg_end" v-if="count>1" :class="{on:active==count}" v-text="count" @click="postPage(count)"></div>

        <!-- <div class="page_btn arr_right"></div> -->
    </div>
</template>

<script>
    export default {
        name: 'pagination',
        props: [
            'active',
            'count'
        ],
        data() {
            return {
                onItem: this.active || ""
            };
        },
        methods: {
            postPage(i){
                if (i!=this.active) {
                    this.$emit('changePage', i);                    
                }
            },
        },
        created() {},
        mounted() {}
    };
</script>

<style lang="scss" scoped>
    $cl_green: #50BBE5;
    $cl_dark: #444444;
    .pagination{
        font-size: 0;
        text-align: center;
        .page_btn{
            display: inline-block;
            line-height: .3rem;
            font-size: .12rem;
            width: .3rem;
            height: .3rem;
            color: $cl_dark;
            border: 1px solid #CCCCCC;
            border-radius: .04rem;
            margin: 0 .05rem;
            box-sizing: border-box;
            vertical-align: middle;
            &.on{
                background: $cl_green;
                border-color: $cl_green;
                color: #ffffff;
            }
            // &.arr_left{
            //     background: url(./img/page_left_nor.svg) center center no-repeat;
            //     background-size: contain;
            //     border:0;
            // }
            // &.arr_right{
            //     background: url(./img/page_right_nor.svg) center center no-repeat;
            //     background-size: contain;
            //     border:0;
            // }
        }
    }
</style>


